const QuestionMark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20}
    height={20}
    viewBox="0 0 302.967 302.967"
    style={{ cursor: "pointer" }}
    {...props}
  >
    <path
      d="M151.483 302.967C67.956 302.967 0 235.017 0 151.483S67.956 0 151.483 0s151.483 67.956 151.483 151.483-67.949 151.484-151.483 151.484zm0-278.551c-70.066 0-127.067 57.001-127.067 127.067S81.417 278.55 151.483 278.55 278.55 221.549 278.55 151.483 221.555 24.416 151.483 24.416z"
      style={{
        fill: "gray",
      }}
    />
    <path
      d="M116.586 118.12c1.795-4.607 4.297-8.588 7.511-11.961 3.225-3.389 7.114-6.016 11.667-7.898 4.547-1.904 9.633-2.845 15.262-2.845 7.261 0 13.32.995 18.183 2.997 4.857 1.996 8.768 4.482 11.738 7.441 2.964 2.97 5.091 6.168 6.369 9.584 1.273 3.432 1.915 6.636 1.915 9.595 0 4.901-.642 8.947-1.915 12.118-1.278 3.171-2.866 5.88-4.759 8.131-1.898 2.252-3.987 4.172-6.293 5.755a147.159 147.159 0 0 0-6.516 4.759 30.34 30.34 0 0 0-5.445 5.439c-1.588 2.04-2.589 4.601-2.991 7.664v5.831H140.6v-6.908c.305-4.395 1.153-8.072 2.529-11.036 1.382-2.964 2.991-5.499 4.83-7.598 1.844-2.089 3.786-3.911 5.836-5.445a105.25 105.25 0 0 0 5.673-4.591c1.73-1.545 3.144-3.225 4.221-5.069 1.071-1.833 1.556-4.15 1.452-6.908 0-4.705-1.148-8.18-3.454-10.427-2.295-2.257-5.493-3.378-9.589-3.378-2.758 0-5.134.533-7.131 1.605s-3.628 2.513-4.911 4.302c-1.278 1.795-2.225 3.894-2.834 6.288-.615 2.415-.919 4.982-.919 7.756h-22.55c.097-5.536 1.038-10.589 2.833-15.201zm45.95 65.818v23.616h-24.09v-23.616h24.09z"
      style={{
        fill: "gray",
      }}
    />
  </svg>
);
export default QuestionMark;
